import { getCurrentOrganization } from '@/lib/utils.ts'
import type { SettingsScope } from '@/lib/queryKeys.ts'

/**
 * Build the cache scope for a settings collection.
 *
 * Lives apart from `queryKeys.ts` so that module stays free of store imports and its own test can
 * exercise the key shapes without booting the user store.
 *
 * `organizationId` is read at CALL time rather than captured, because these scopes are built inside
 * Mercure callbacks that outlive the render they were created in — a captured id would keep writing
 * into the previous organization's cache entry after a switch.
 */
export const settingsScope = (projectId?: string): SettingsScope => ({
  projectId,
  organizationId: getCurrentOrganization()?.organization?.id,
})
